import { ConfigProvider, Select } from "antd";
import './Select.scss';

const { Option } = Select;

export interface Props {
    id?:string;
    placeholder?: string;
    options: string[] | any;
    showSearch?: boolean;
    onChange?: any;
    onSearch?: any;
    className?: string;
    rtl?: boolean;
    width?: string;
    helperText?: string;
    defaultValue?: string;
    value?: string;
    headingLeft?: string;
    headingRight?: string;
    disabled?: boolean;
}

const SelectComponent = ({id, onSearch, disabled, value, defaultValue, placeholder, onChange, className = '', headingLeft, headingRight, rtl = false, showSearch = false, width, options, helperText, ...props }: Props) => {
    const textAlign = rtl ? 'right' : 'left';
    const dir = rtl ? 'rtl' : 'ltr';

    const dropdownOption = options.map((item: any, i: any) => {
        return (
            <Option className="sansFont" value={item.value ? item.value : item.text} key={item.text + i}>
                <div className="storybook__select--option-item">
                    <div role="img" aria-label={item.id}>
                        {item.icon}
                        {item.text}
                    </div>
                </div>
            </Option>
        )
    })

    return (
        <ConfigProvider direction={dir}>
            <div className='storybook__select--container' style={{ float: textAlign, width, textAlign }}>
                <div className={rtl ? 'heading-section rightDir' : 'heading-section'}>
                    <div className='heading-left'>{headingLeft !== '' ? headingLeft : ''}</div>
                    <div className='heading-right'>{headingRight !== '' ? headingRight : ''}</div>
                </div>
                <Select
                    id={id}
                    className={`sansFont ${className}`}
                    style={{ float: textAlign, width, textAlign }}
                    placeholder={placeholder}
                    showSearch={showSearch}
                    onChange={onChange}
                    onSearch={onSearch}
                    defaultValue={defaultValue}
                    value={value ? value : undefined}
                    disabled={disabled}
                    {...props}
                >
                    {dropdownOption}
                </Select>
                {helperText && (
                    <div className='storybook__select--helperText' style={{ float: textAlign, width, textAlign }}>
                        <label>{helperText}</label>
                    </div>
                )}
            </div>
        </ConfigProvider>
    )
}

export default SelectComponent;